export default __webpack_public_path__ + "static/media/1296.42bd4d6b.png";